import { getDefaultState } from "./moduleReportFormConfigState";

export default {
	SET_REPORT_FORM: (state, reportForm) => {
		state.reportForm = reportForm;
	},

	UPDATE_REPORT_FORM: (state, reportForm) => {
		state.reportForm = reportForm;
	},

	ADD_REPORT_FORM_FIELD(state, payload) {
		state.reportForm = {
			...state.reportForm,
			controls: [...state.reportForm.controls, payload]
		};
	},

	UPDATE_REPORT_FORM_FIELD(state, payload) {
		const indexField = state.reportForm.controls.findIndex(
			t => t.id === payload.id
		);
		if (indexField !== -1) {
			Object.assign(state.reportForm.controls[indexField], payload);
		}
	},

	DELETE_REPORT_FORM_FIELD(state, id) {
		state.reportForm = {
			...state.reportForm,
			controls: state.reportForm.controls.filter(field => field.id !== id)
		};
	},

	SORT_REPORT_FORM_FIELD(state, payload) {
		state.reportForm = {
			...state.reportForm,
			controls: [...payload]
		};
	},

	SET_GENERAL_DATA(state, payload) {
		state.generalData = JSON.parse(payload);
		state.isLoadedGeneralData = true;
	},

	RESET_STATE(state) {
		Object.assign(state, getDefaultState());
	}
};
